import type {
  CurrencyAmount,
  IsoDateTime,
} from '@omnipresentgroup/design-system';

import type { AddressAPI, Country } from '../../common';
import type { ContractorPayment, FeeType } from '../payments';

/** API */

export enum PaymentMethodAPI {
  MANUAL_BANK_TRANSFER = 'DIRECT_BANK_WIRE',
  CREDIT_CARD = 'CREDIT_CARD',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export type ContractorPaymentTransferDetailsAPI = {
  iban_bank_account: {
    owner_name: string;
    owner_address: AddressAPI;
    bank_account_type: 'IBAN';
    iban: string;
    swift_bic?: string;
  };
  gb_bank_account?: {
    owner_name: string;
    owner_address: AddressAPI;
    bank_account_type: 'GB';
    account_number: string;
    sort_code: string;
  };
  wire_reference: string;
};

export type FxAPI = {
  conversion: {
    from_currency: string;
    to_currency: string;
    effective_rate: string;
  };
  markup_rate: string;
};

export type FeeAPI = {
  amount: CurrencyAmount;
  type: FeeType;
  month?: string;
};

export type BaseQuoteAPI = {
  base_amount: CurrencyAmount;
  converted_amount: CurrencyAmount;
  fees: FeeAPI[];
  transfer_amount: CurrencyAmount;
  fx?: FxAPI;
  vat_rate: string;
  country: Country;
};

export type InvoiceQuoteAPI = BaseQuoteAPI & {
  invoice_id: string;
  invoice_ref: string;
  contractor: { id: string; name: string };
};

export type ContractorPaymentQuoteAPI = {
  quote_id: string;
  expires_at: IsoDateTime;
  invoices_breakdown: InvoiceQuoteAPI[];
  quote_summary: BaseQuoteAPI;
  payment_type: PaymentMethodAPI;
};

export type ContractorPaymentAPI = {
  id: string;
  created_at: IsoDateTime;
  transfer_details?: ContractorPaymentTransferDetailsAPI;
  transfer_details_available_until: IsoDateTime;
  funds_received_at?: IsoDateTime;
  paid_out_at?: IsoDateTime;
  quote: ContractorPaymentQuoteAPI;
};

export type GetContractorPaymentResponseAPI = ContractorPaymentAPI;

/** Model */

export type GetContractorPaymentResponse = ContractorPayment;
